import WsCard from './card.vue'

export default WsCard
